import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class CookiesService {

  constructor(  private http: HttpClient, 
                private serviceCallUtilsService: ServiceCallUtilsService
              ) { }

  getGroupParameters(param) {
    return this.serviceCallUtilsService.callSecuredGetWebService(constants.ENDPOINT_GROUP_POLICIES + param);
  }
}
